import SplitType from "split-type";

export type SplitTypeChars = {
    chars: HTMLElement[];
    revert: () => void;
};

export type SplitTypeTitle = {
    chars: HTMLElement[];
    lines: HTMLElement[];
    words: HTMLElement[];
    revert: () => void;
};

export class SplitTypeWrapper {
    static splitChars(target: HTMLElement): SplitTypeChars {
        const split = new SplitType(target, {
            types: "chars",
            tagName: "span",
        });

        return {
            chars: (split.chars ?? []) as HTMLElement[],
            revert: () => split.revert(),
        };
    }

    static splitTitle(target: HTMLElement): SplitTypeTitle {
        const split = new SplitType(target, {
            types: "lines,words,chars",
            tagName: "span",
        });

        return {
            chars: (split.chars ?? []) as HTMLElement[],
            lines: (split.lines ?? []) as HTMLElement[],
            words: (split.words ?? []) as HTMLElement[],
            revert: () => split.revert(),
        };
    }
}
